import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_FOLDER_STATE } from 'redux/folders/actions/types'

import DeckGridItem from 'components/folderPage/FolderGrid/DeckGridItem'
import FolderGridItem from 'components/folderPage/FolderGrid/FolderGridItem'
import Icon from 'components/elements/Icon'
import Link from 'components/elements/Link'
import { gridClassUnlocked } from 'components/misc/DeckLink'

import styles from './folderGrid.module.scss'

const FolderGrid = () => {
  const rootFolderId = useAppSelector(state => state.folders.rootFolder?.id)
  const parentFolderId = useAppSelector(state => state.folders.rootFolder.parentFolder?.id)
  const subfolders = useAppSelector(state => state.folders.rootFolder.subfolders)
  const decks = useAppSelector(state => state.folders.rootFolder.decks)
  const selectedFolders = useAppSelector(state => state.folders.selectedSubfolders)
  const selectedDecks = useAppSelector(state => state.folders.selectedDecks)

  const [setFolderState] = useActionless(SET_FOLDER_STATE)

  return (
    <div className={styles.container}>
      <div className={styles.folderGrid}>
        {!!parentFolderId && (
          <FolderGridItem
            // @ts-ignore
            folder={{ id: parentFolderId, name: 'Parent folder', private: false, createdAt: '' }}
            notSelectable
          />
        )}

        {subfolders.map(subFolder => (
          <FolderGridItem
            folder={subFolder}
            key={subFolder.id}
            onToggleSelected={() =>
              setFolderState({
                selectedSubfolders: { ...selectedFolders, [subFolder.id]: !selectedFolders[subFolder.id] },
              })
            }
          />
        ))}

        <button className={styles.newFolderGridButton} onClick={() => setFolderState({ newFolderModalOpen: true })}>
          <Icon name="add circle" />
          New folder
        </button>
      </div>

      <div className={`${gridClassUnlocked} ${styles.deckGrid}`}>
        {decks.map(deck => (
          <DeckGridItem
            key={deck.id}
            deck={deck}
            onToggleSelected={() =>
              setFolderState({
                selectedDecks: { ...selectedDecks, [deck.id]: !selectedDecks[deck.id] },
              })
            }
          />
        ))}

        <Link href={`/new-deck/?parentFolderId=${rootFolderId}`} className={styles.newDeckButton}>
          <button>
            <Icon name="add circle" /> New deck
          </button>
        </Link>
      </div>
    </div>
  )
}

export default FolderGrid
